import contractFields from '../../../fields/contractFields';
import DropdownContractActionsRow from '../../dropdown/DropdownContractActionsRow';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderApplication from '../../application/RenderApplication';
import RenderBankCode from '../../bankCode/RenderBankCode';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import RenderRank from '../../rank/RenderRank';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';

export const columnsContractId = 'contracts';
export const columnsContract = (headerPackage) => {
    const show = true;

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsContractId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: contractFields.UUID,
            headerPackage: headerPackage,
            show: !headerPackage.selectionMode,
            customCellFn: ({ row }) => (
                row &&
                <DropdownContractActionsRow contract={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.ADDED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.ADDED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderApplication applicationCode={cell.getValue(contractFields.APPLICATION.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.RANK,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderRank rank={cell.getValue(contractFields.RANK.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(contractFields.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.MERCHANT_LABEL,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.IDSA,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.MCC,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.MERCHANT_NAME,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage,
            show: show
        })
    ].filter(col => !!col));
};